var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNfcSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.103,
    height: 19.641,
    viewBox: "0 0 49.103 19.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1489",
    "data-name": "Rectangle 1489",
    width: 49.103,
    height: 19.641,
    fill: "#1d1d1b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M18.554,4.086a6.707,6.707,0,0,1,0,6.337.982.982,0,0,0,1.725.938,8.679,8.679,0,0,0,0-8.212A.981.981,0,0,0,18.554,4.086Z",
    transform: "translate(17.967 2.568)",
    fill: "#1d1d1b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M22.911,1.549a17.55,17.55,0,0,1,.02,16.508.985.985,0,1,0,1.653,1.067,19.516,19.516,0,0,0,0-18.606A.984.984,0,1,0,22.911,1.549Z",
    transform: "translate(22.158 0.001)",
    fill: "#1d1d1b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M20.7,2.776a12.019,12.019,0,0,1,0,11.519.981.981,0,0,0,1.719.948,14,14,0,0,0,0-13.417.982.982,0,0,0-1.719.95",
    transform: "translate(20.06 1.284)",
    fill: "#1d1d1b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M7.85,1.979V12.022L1.833,1.493A.981.981,0,0,0,0,1.979V15.716a.982.982,0,0,0,1.964,0V5.675L7.981,16.2a.981.981,0,0,0,1.831-.488V1.979a.981.981,0,0,0-1.962,0",
    transform: "translate(0 0.973)",
    fill: "#1d1d1b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M13.829,1H7.943a.982.982,0,0,0-.982.982V15.716a.981.981,0,0,0,1.962,0V10.809h2.945a.981.981,0,0,0,0-1.962H8.923V2.959h4.907a.981.981,0,0,0,0-1.962",
    transform: "translate(6.79 0.973)",
    fill: "#1d1d1b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M15.86,2.96a1.965,1.965,0,0,1,1.962,1.962.982.982,0,0,0,1.964,0,3.925,3.925,0,0,0-7.85,0v7.85a3.925,3.925,0,1,0,7.85,0,.982.982,0,0,0-1.964,0,1.962,1.962,0,1,1-3.923,0V4.921A1.965,1.965,0,0,1,15.86,2.96",
    transform: "translate(11.641 0.974)",
    fill: "#1d1d1b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfcSvg);
export default __webpack_public_path__ + "static/media/NFC_svg.78ea11089d008f23bfc98022690e2095.svg";
export { ForwardRef as ReactComponent };